import type { VariantProps } from 'class-variance-authority'
import { cva } from 'class-variance-authority'

export { default as Text } from './Text.vue'

export const textVariants = cva('', {
  variants: {
    variant: {
      body: '',
      label: '',
      code: 'font-mono',
    },
    size: {
      lg: '',
      base: '',
      sm: '',
      xs: '',
    },
  },
  compoundVariants: [
    { variant: 'body', size: 'lg', class: 'text-body-lg' },
    { variant: 'body', size: 'base', class: 'text-body-base' },
    { variant: 'body', size: 'sm', class: 'text-body-sm' },
    { variant: 'body', size: 'xs', class: 'text-body-xs' },
    { variant: 'label', size: 'lg', class: 'text-label-lg' },
    { variant: 'label', size: 'base', class: 'text-label-base' },
    { variant: 'label', size: 'sm', class: 'text-label-sm' },
    { variant: 'label', size: 'xs', class: 'text-label-xs' },
    { variant: 'code', size: 'lg', class: 'text-code-base' },
    { variant: 'code', size: 'base', class: 'text-code-base' },
    { variant: 'code', size: 'sm', class: 'text-code-sm' },
    { variant: 'code', size: 'xs', class: 'text-code-sm' },
  ],
  defaultVariants: {
    variant: 'body',
    size: 'base',
  },
})

export type TextVariants = VariantProps<typeof textVariants>
